import React, { Fragment } from "react";
import { useEffect } from "react";

import { useConfig } from "../../core/config";
import { useAnalytics } from "../../lib/analytics/analytics";
import { makeGA4Client } from "../../lib/analytics/ga4";
import { makePixelClient } from "@/lib/analytics/pixel";
import { makeHubspotClient } from "@/lib/analytics/hubspot";
import { makeGTMClient } from "@/lib/analytics/gtm";

export function useTheMalinAnalytics() {
  const config = useConfig();
  const analytics = useAnalytics();

  useEffect(() => {
    const variables = envVariables[config.environment];

    const hubspotClient = makeHubspotClient();

    analytics.addClient(hubspotClient);

    if (variables.fbPixelId) {
      const pixelClient = makePixelClient(variables.fbPixelId);

      analytics.addClient(pixelClient);
    }

    if (variables.ga4TrackingId) {
      const ga4Client = makeGA4Client({
        trackingId: variables.ga4TrackingId,
        gaOptions: {
          name: "themalin",
        },
      });

      analytics.addClient(ga4Client);
    }

    if (variables.gtmId) {
      const gtmClient = makeGTMClient({ gtmId: variables.gtmId });

      analytics.addClient(gtmClient);
    }
  }, [config.environment, analytics]);
}

const envVariables = {
  development: {
    ga4TrackingId: "",
    gtmId: "",
    fbPixelId: "",
  },
  staging: {
    ga4TrackingId: "G-JL5GV5CQ7D",
    gtmId: "",
    fbPixelId: "",
  },
  production: {
    ga4TrackingId: "G-3XH3BNR5LV",
    gtmId: "GTM-N57RHLNC",
    fbPixelId: "378420720441138",
  },
};

export default function TheMalinAnalytics(): JSX.Element {
  useTheMalinAnalytics();

  return <Fragment></Fragment>;
}
